import type { AiRecommendationResponse } from '@viome/viome-base/src/usecase/AiRecommendation/AiRecommendationModel';

const ELIGIBILITY_WINDOW_MONTHS = 24;

function eligibilityCutoffMs(): number {
  const cutoff = new Date();
  cutoff.setMonth(cutoff.getMonth() - ELIGIBILITY_WINDOW_MONTHS);
  return cutoff.getTime();
}

export function isWrappedEligibleV2(
  ai: AiRecommendationResponse | undefined | null,
): boolean {
  if (!ai) return false;

  if (ai.user_profile?.kit_type !== 'FBI') return false;
  if (!ai.scores?.health_zones?.length) return false;
  if (!ai.foods?.some((f) => f.narratives?.length > 0)) return false;
  if (!ai.user_profile?.self_reported_goals?.length) return false;

  const releaseDate = ai.user_profile?.release_date;
  if (!releaseDate) return false;
  const releasedMs = new Date(releaseDate).getTime();
  if (Number.isNaN(releasedMs)) return false;
  return releasedMs >= eligibilityCutoffMs();
}
